import send from '../request';

// 国家列表（含 国家logo、国家名称、国家 dialling_code 等）
export function publicArea(data = {}, loading = true) {
  return send({ url: '/ipp/v3/public/area', method: 'POST', data, options: { loading } });
}

// 级联查询地区（省市区名称查询）
export function publicAreaByName(data = {}, loading = true) {
  return send({ url: '/ipp/v3/public/area-by-name', method: 'POST', data, options: { loading } });
}

// 全量地区列表
export function publicAreaAll(data = {}, loading = true) {
  return send({ url: '/ipp/v3/public/area-all', method: 'POST', data, options: { loading } });
}

// 经营品类 - 全品类
export function enumCatList(data = {}) {
  return send({ url: '/ipp/v3/enum/cat-list', method: 'POST', data });
}

// 获取用户信息
export function userCurrentUser(data = {}) {
  return send({ url: '/ipp/v3/user/current-user', method: 'POST', data });
}

// 获取用户信息
export function publicLoginForSign(data = {}, queryParams = {}) {
  return send({ url: '/ipp/v3/public/login-for-sign', method: 'POST', data, options: { externalAuth: queryParams } });
}

// CPM获取用户信息
export function publicLoginForCpm(data = {}, queryParams = {}) {
  return send({ url: '/ipp/v3/public/login-for-cpm', method: 'POST', data, options: { externalAuth: queryParams } });
}

// 菜单列表
export function commonMenus(data = {}) {
  return send({ url: '/ipp/v3/common/menus', method: 'POST', data });
}

// 币种汇率获取
export function publicCurrency(data = {}) {
  return send({ url: '/ipp/v3/public/currency', method: 'POST', data });
}

//供应商
export function enumSuppliers(data = {}) {
  return send({ url: '/ipp/v3/enum/suppliers', method: 'POST', data });
};

// 获取ossToken
export function publicOssToken(params = {}) {
  return send({ url: '/ipp/v3/public/oss-token', method: 'GET', params });
}

// 公司仓库列表
export function userAddressWarehouseList(params = {}) {
  return send({ url: '/ipp/user-address/warehouse-list', method: 'POST', data: params });
}

// PV统计接口
export function apiLog(params = {}) {
  return send({ url: '/api/log', method: 'POST', data: params });
};

// 公司风险信息
export function companyRisk(params = {}) {
  return send({ url: '/ipp/v3/company/risk', method: 'POST', data: params });
};

// 顶级分类列表
export function homeTopCategory(params = {}) {
  return send({ url: '/ipp/v3/home/top-category', method: 'POST', data: params });
};

// 消息列表
export function messageSelect(params = {}) {
  return send({ url: '/ipp/v3/message/select', method: 'POST', data: params });
};

// 及时消息列表
export function messageNewMessage(params = {}) {
  return send({ url: '/ipp/v3/message/new-message', method: 'POST', data: params, options: { loading: false } });
};

// 消息列表-全部已读
export function messageReadAll(params = {}) {
  return send({ url: '/ipp/v3/message/read-all', method: 'POST', data: params });
};

//消息-已读
export function messageRead(params = {}) {
  return send({ url: '/ipp/v3/message/read', method: 'POST', data: params });
}

// 用户关联公司列表
export function userJoinCompanys(params = {}) {
  return send({ url: '/ipp/v3/user/join-companys', method: 'POST', data: params });
};

// 切换当前公司
export function userSwitchCompanys(params = {}) {
  return send({ url: '/ipp/v3/user/switch-companys', method: 'POST', data: params });
};

// OCR识别服务-营业执照
export function publicOcrBusinessLicense(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-business-license', method: 'POST', data: params });
};

// OCR识别服务-身份证（正反面）
export function publicOcrIdCard(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-idcard', method: 'POST', data: params });
};

// OCR识别服务-食品食品生产加工许可证
export function publicOcrProLicense(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-pro-license', method: 'POST', data: params });
};

// OCR识别服务-进出口资质识别
export function publicOcrIeQualification(params = {}) {
  return send({ url: '/ipp/v3/public/ocr-ie-qualification', method: 'POST', data: params });
};

export function supplierApplyInfo(params = {}) {
  return send({ url: '/ipp/v3/supplier-apply/info', method: 'POST', data: params });
};

// 公司关键信息变更-查看
export function companyCoreUpdateInfo(data = {}) {
  return send({ url: '/ipp/v3/company/core-update-info', method: 'POST', data });
};

// 入驻创建公司
export function purchaseCreate(data = {}) {
  return send({ url: '/ipp/v3/purchase/create', method: 'POST', data });
};